export enum Navegacoes {
  DadosPessoais = 'dados-pessoais',
  Contato = 'contato',
  DadosFinanceiros = 'dados-financeiros',
  Residencia = 'residencia',
  ResumoAcademico = 'resumo-academico'
}
